// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__1VB2h","container":"styles_container__3sMI2","copy":"styles_copy__3xPlq","copyValue":"styles_copyValue__3Ws3k"};